import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import pl from "./pl";
import en from "./en";

function initTranslations() {
  return i18next.use(initReactI18next).init({
    resources: {
      pl: {
        translation: pl
      },
      en: {
        translation: en
      }
    },
    lng: "pl",
    fallbackLng: "pl",
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false
    }
  });
}

export default initTranslations;
